<template>
    <form>
        <div class="bet-name">
            <span>{{'random' | translate }}</span>
        </div>
        <div id="bet-area" class="betting-inputs">
            <input v-model="bettingSvc.random"
                   id="random"
                   type="number"
                   v-random-bet-validator
                   @keydown="checkChars"
                   @keydown.enter.prevent="setFocus()"
                   @keydown.tab.prevent="setFocus()"
                   @click="setFocus()"
                   autocomplete="off"
                   :disabled="isBettingDisabled"
            >
        </div>
    </form>
</template>

<script>

    import {BettingSvc} from '../../../services/betting.service';
    import {RandomBetValidator} from '../../../directives/randombet_validator';
    import {EventBus}   from '../../../utilities/event.bus';
    import {random} from'../../../utilities/random';
    import {invalidChars} from '../../../utilities/invalidCharsChecker';
    import {GameSvc} from '../../../services/game.service';
    import {translate} from '../../../filters/translate';

    let betForm;

    export default {
        name: 'RandomBet',

        directives: {
            RandomBetValidator,
        },
        filters: {
            translate,
        },
        data() {
            return {
                bettingSvc : BettingSvc.getBettingSvc(),
                random : 'random'
            }
        },
        computed: {
            isBettingDisabled () {
                return GameSvc.getGameSvc().gameInfo.betsBlocked;
            }
        },

        mounted(){
            betForm = document.getElementById('bet-area') ? document.getElementById('bet-area').getElementsByTagName('input') : '';
            this._subscribeEvents();
            this.setFocus();
        },

        destroyed(){
            this.unsubscribeEvents();
        },

        methods: {
            checkChars(event) {
                invalidChars(event)
            },

            /**
             * Set focus on right input
             */

            setFocus() {
                if(!betForm) return;

                betForm[0].focus();

                // create random values
                if(betForm[0].value){
                    this.bettingSvc.ticket.input = random(betForm[0].value, 1, 80);
                }

                // if input is empty don't resolve bet
                if(!betForm[0].value){
                    return;
                }

                // if future bet is active set focus on future bet input
                if( betForm[0].value &&
                    document.getElementById('future')){
                    document.getElementById('future').select();
                    return;
                }

                // resolve bet
                try {
                    this.bettingSvc.finalizeTicket();
                } catch (err) {
                    return;
                }

                //reset
                EventBus.$emit('keydown', {
                    key : '+'
                });

            },

            /**
             * Subscribe events
             * @private
             */

            _subscribeEvents(){

                EventBus.$on('Keno.FutureBetValid', () => {
                    this.setFocus();
                    try {
                        this.bettingSvc.finalizeTicket();
                    } catch (err) {
                        return;
                    }
                    this.resetAll();
                });

            },

            /**
             * Reset betting service and activate normal bet
             */

            resetAll() {
                this.bettingSvc.clearAll();
                EventBus.$emit('keydown',{
                    key : '+'
                });

            },

            /**
             * Unsubscribe events
             */

            unsubscribeEvents(){
                EventBus.$off('Keno.FutureBetValid');
            }
        }
    };

</script>

<style  lang="scss">
    @import '../../../assets/style/shop/betting';

</style>



// WEBPACK FOOTER //
// RandomBet.vue?29a8500a